import { useEffect, useState } from 'react'
import { Platform } from 'react-native'

/**
 * Whether the browser reports a network connection (web only, via
 * navigator.onLine and its online/offline events). Native has no network
 * status module in the app, so it always reports true there and the
 * connection notice uses actual HTTP failures or slow requests there.
 * Native-safe: web globals are read behind Platform/typeof guards.
 */
export function useBrowserOnline(): boolean {
  const read = () =>
    Platform.OS !== 'web' || typeof navigator === 'undefined' || navigator.onLine !== false
  const [online, setOnline] = useState(read)
  useEffect(() => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return
    const update = () => setOnline(read())
    window.addEventListener('online', update)
    window.addEventListener('offline', update)
    return () => {
      window.removeEventListener('online', update)
      window.removeEventListener('offline', update)
    }
  }, [])
  return online
}
